import React from 'react';

import { EditAuthorizedPdfForm, Header } from 'components';

export const EditAuthorizedPdf = () => {
  return (
    <>
      <Header />
      <EditAuthorizedPdfForm />
    </>
  );
};
